import styled from 'styled-components';

export const StyledPrice24hCol = styled.td`
        & > span {
            width: max-content;
        }
`

export const StyledCoinLogo = styled.img`
    width: 32px;
    height: 32px;
    margin-right: 15px;
`

export const StyledCoinName = styled.span`
    color: #FFF;
    font-size: 16px;
    font-weight: 500;
`
